(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7711,8545],{

/***/ 28086:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/property/[property]",
      function () {
        return __webpack_require__(47574);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 88545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Addons; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81380);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_2__);



function Addons(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_2___default()), {
                src: "https://kit.fontawesome.com/3c7cbada9c.js",
                crossOrigin: "anonymous",
                async: true
            }),
            props.hasOwnProperty("script_sections") ? props.script_sections != null ? props.script_sections.map(function(section, key) {
                return(// section.app_section_content
                section.app_section_content != null ? !section.app_section_content.includes("platform") ? section.app_section_content.split("<script>")[1] != null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    src: section.app_section_content.split("<script>")[1].split("</script>")[0],
                    defer: true
                }, key) : "" : "" : "");
            }) : "" : ""
        ]
    });
}


/***/ }),

/***/ 1860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ page; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);

var page = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    pageId: -1,
    isMobile: 0,
    isTablet: 0,
    isDesktop: 0,
    isPublicDomain: 0,
    appSettings: [],
    destinationId: null,
    propertiesParams: {
        page_id: null,
        limit: 24,
        offset: 0,
        destinations: [],
        tags: [],
        themes: [],
        locations: [],
        statuses: 3
    }
});


/***/ }),

/***/ 9820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PropertyComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31969);
/* harmony import */ var _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95623);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18256);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_Addons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88545);
/* harmony import */ var _fortawesome_fontawesome_svg_core_styles_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54197);
/* harmony import */ var _fortawesome_fontawesome_svg_core_styles_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_fortawesome_fontawesome_svg_core_styles_css__WEBPACK_IMPORTED_MODULE_6__);







_fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_3__/* .config.autoAddCss */ .vc.autoAddCss = false;
var PropertySections = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5693), __webpack_require__.e(8201), __webpack_require__.e(8340), __webpack_require__.e(3098), __webpack_require__.e(77), __webpack_require__.e(8567), __webpack_require__.e(9656), __webpack_require__.e(2817), __webpack_require__.e(9445), __webpack_require__.e(5175), __webpack_require__.e(4795), __webpack_require__.e(2368), __webpack_require__.e(1100), __webpack_require__.e(2405), __webpack_require__.e(6442), __webpack_require__.e(6171), __webpack_require__.e(4906), __webpack_require__.e(5885), __webpack_require__.e(9350), __webpack_require__.e(8630), __webpack_require__.e(5992), __webpack_require__.e(2511), __webpack_require__.e(5993), __webpack_require__.e(9771)]).then(__webpack_require__.bind(__webpack_require__, 55993));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55993)
            ];
        }
    },
    suspense: true
});
var Scripts = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7452), __webpack_require__.e(9764), __webpack_require__.e(5419)]).then(__webpack_require__.bind(__webpack_require__, 85419));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85419)
            ];
        }
    },
    ssr: false
});
var PropertyScripts = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7452), __webpack_require__.e(1344)]).then(__webpack_require__.bind(__webpack_require__, 81344));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81344)
            ];
        }
    },
    ssr: false
});
function PropertyComponent(props) {
    var isDesktop = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["appSettings"]["isDesktop"];
    });
    var app = props.app;
    var head = props.head;
    var content = props.content;
    var all_images = props.all_images;
    var features = props.features;
    var builder = props.builder;
    var footer = props.footer;
    var app_data = props.app_data;
    var locations = props.locations;
    var navigation = props.navigation;
    var captchaSiteKey = "6Ldn5jYUAAAAAHV8v0apDoa8Hd1O67fo92WqpWRY";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PropertySections, {
                    isDesktop: isDesktop,
                    app_data: app_data,
                    head: head,
                    app: app,
                    builder: builder,
                    navigation: navigation,
                    content: content,
                    locations: locations,
                    footer: footer,
                    captchaSiteKey: captchaSiteKey,
                    all_images: all_images,
                    features: features,
                    page_title: content.page_title,
                    phone: (head.location[0].phoneCountryCode != undefined ? "+" + head.location[0].phoneCountryCode : "+30") + " " + head.location[0].phone,
                    removeHeader: props.removeHeader
                }, 2)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Scripts, {}, 3),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PropertyScripts, {}, 4),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Addons__WEBPACK_IMPORTED_MODULE_5__["default"], {
                script_sections: null
            }, 5)
        ]
    });
}


/***/ }),

/***/ 47574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Property": function() { return /* binding */ Property; },
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(82770);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4012);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31969);
/* harmony import */ var _fancyapps_ui_dist_fancybox_esm__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46797);
/* harmony import */ var _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95623);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18256);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_AppContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1860);
/* harmony import */ var _components_entities_property__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9820);
/* harmony import */ var _components_head_BuilderHead__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56951);
/* harmony import */ var _components_templates_index_partials_InlineStyles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53408);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(83974);
/* harmony import */ var _fortawesome_fontawesome_svg_core_styles_css__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(54197);
/* harmony import */ var _fortawesome_fontawesome_svg_core_styles_css__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_fortawesome_fontawesome_svg_core_styles_css__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _layouts_MainLayout__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(28207);





// import PropertySections from "../../components/templates/property/sections/PropertySections";










_fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_4__/* .config.autoAddCss */ .vc.autoAddCss = false;
var PropertySections = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3098), __webpack_require__.e(77), __webpack_require__.e(8567), __webpack_require__.e(2817), __webpack_require__.e(9445), __webpack_require__.e(5175), __webpack_require__.e(4795), __webpack_require__.e(2368), __webpack_require__.e(1100), __webpack_require__.e(2405), __webpack_require__.e(6171), __webpack_require__.e(4906), __webpack_require__.e(5885), __webpack_require__.e(9350), __webpack_require__.e(8630), __webpack_require__.e(5992), __webpack_require__.e(2511), __webpack_require__.e(5993), __webpack_require__.e(8512)]).then(__webpack_require__.bind(__webpack_require__, 55993));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55993)
            ];
        }
    },
    suspense: true
});
var Scripts = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7452), __webpack_require__.e(9764), __webpack_require__.e(5419)]).then(__webpack_require__.bind(__webpack_require__, 85419));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85419)
            ];
        }
    },
    ssr: false
});
var PropertyScripts = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7452), __webpack_require__.e(1344)]).then(__webpack_require__.bind(__webpack_require__, 81344));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81344)
            ];
        }
    },
    ssr: false
});
var __N_SSP = true;
var Property = function(props) {
    var pageContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_components_AppContext__WEBPACK_IMPORTED_MODULE_6__/* .page */ .M);
    pageContext.pageId = props.app_data.page_id;
    pageContext.appSettings = props.app;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), urlHref = ref[0], setUrlHref = ref[1];
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        _fancyapps_ui_dist_fancybox_esm__WEBPACK_IMPORTED_MODULE_3__/* .Fancybox.bind */ .KR.bind("[data-fancybox]", {
            Image: {
                zoom: false
            },
            on: {
                load: function() {
                    if (document !== undefined) {
                        var modal = document.querySelector(".modal");
                        if (modal) modal.classList.remove("show");
                    }
                },
                destroy: function() {
                    if (document !== undefined) {
                        var modal = document.querySelector(".modal");
                        if (modal) modal.classList.add("show");
                    }
                }
            }
        });
        if (window !== undefined) {
            setUrlHref(window.location.href + "/");
        }
    }, [
        urlHref
    ]);
    var domain = props.domain;
    var app = props.app;
    var builder = props.builder;
    var head = props.head;
    var footer = props.footer;
    var app_data = props.app_data;
    var locations = props.locations;
    var navigation = props.navigation;
    var content = props.content;
    var all_images = props.all_images;
    var features = props.features;
    var rgbDesignColor = props.rgbDesignColor;
    var rgbSearchbarColor = props.rgbSearchbarColor;
    var isDesktop = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["appSettings"]["isDesktop"];
    }); // props.isDesktop;
    var captchaSiteKey = "6Ldn5jYUAAAAAHV8v0apDoa8Hd1O67fo92WqpWRY";
    var meta_desc = content.details.meta_desc == null ? content.details.description : content.details.meta_desc;
    var getMetaImage = function() {
        if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_10__/* ["default"].isValidArray */ .Z.isValidArray(props.content.album) && _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_10__/* ["default"].isValidString */ .Z.isValidString(props.content.album[0].image)) {
            return props.content.album[0].image;
        }
        return _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_10__/* ["default"].isValidArray */ .Z.isValidArray(head.og_image) ? head.og_image[0].image : null;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layouts_MainLayout__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_templates_index_partials_InlineStyles__WEBPACK_IMPORTED_MODULE_9__/* .InlineStyles */ .f, {
                app: app,
                rgbDesignColor: rgbDesignColor,
                rgbSearchbarColor: rgbSearchbarColor
            }, 0),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_head_BuilderHead__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                title: content.details.property_title + " - " + content.details.motto + " | " + head.data.title,
                keywords: content.details.metaKeywords,
                titleOfficial: head.data.titleOfficial,
                domain: urlHref,
                icon_60: head.data.icon_60,
                icon_76: head.data.icon_76,
                icon_120: head.data.icon_120,
                icon_152: head.data.icon_152,
                icon_256: head.data.icon_256,
                icon: head.data.icon,
                title_fb_meta: content.details.property_title + " - " + content.details.motto,
                desc_fb_meta: meta_desc,
                image_fb_meta: getMetaImage(),
                site_name_fb_meta: head.data.title,
                lat_fb_meta: content.location.latitude,
                lon_fb_meta: content.location.longitude,
                twitter_img_alt: content.details.property_title + " - " + content.details.motto + ". " + content.details.metaDesc,
                googleSchemaContext: domain,
                googleSchemaTitle: head.data.title,
                googleSchemaStreetAddress: head.location[0].address,
                googleSchemaCity: head.location[0].city,
                googleSchemaCountry: head.location[0].country,
                googleSchemaZip: head.location[0].zip,
                googleSchemaPhone: head.location[0].phone,
                designColor: app.designColor,
                font: app.font,
                manager: false,
                property: true
            }, 1),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_entities_property__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                isDesktop: isDesktop,
                app_data: app_data,
                head: head,
                app: app,
                builder: builder,
                navigation: navigation,
                content: content,
                locations: locations,
                footer: footer,
                captchaSiteKey: captchaSiteKey,
                all_images: all_images,
                features: features,
                page_title: content.page_title,
                phone: head.location[0].phone,
                removeHeader: false,
                footerPaddingClass: !isDesktop ? "search-xs-p-b-70" : ""
            }, 2)
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (Property);


/***/ }),

/***/ 81380:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(88512)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5693,4285,8201,8340,9007,5553,5634,9656,8024,6442,8207,1345,9774,2888,179], function() { return __webpack_exec__(28086); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);